import React, { useEffect } from "react";
import Layout from "features/layout/Layout";
import BlogList from "features/blog/BlogList";
export default function BlogListPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Layout>
      <BlogList />
    </Layout>
  );
}
